import { DeleteOtp } from '../../../../../api/gen';

export class DeleteOtpRequest {
  otpIdentifiers?: string[] | null;

  static toRequest(r: DeleteOtpRequest): DeleteOtp {
    return { otpIdentifiers: r.otpIdentifiers } as DeleteOtp;
  }
}
